//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'EKG',
  data() {
    return {
      form: {
        item2: '',
        item3: '',
      },
      hasScore: false,
      disabled: false,
      item1List: [
        { value: '0', name: '秒(0~30)' },
        { value: '1', name: '小格(0~750)' },
      ],
      item2List: [
        { value: '0', name: '25mm/s' },
        { value: '1', name: '50mm/s' },
      ],
      showKey:'小格'
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
    setUnitsValueName(value) {
     this.showKey = value.key
    },
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      if (form.item2 == '') {
        form.item2 = '3'
      }
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let res
        if (this.showKey == 's') {
          res = 60 / form.item3
        } else {
          if (form.item2 == 0) {
            res = 60 / (form.item3 * 0.04)
          } else if (form.item2 == 1) {
            res = 60 / (form.item3 * 0.02)
          }
        }
        self.hasScore = true
        return String(res.toFixed(0))
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/EKG.vue